// src/app/fireworks/fireworks.component.ts
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import confetti from 'canvas-confetti';

@Component({
	selector: 'app-fireworks',
	template: `<canvas #canvasRef class="fireworks-canvas"></canvas>`,
	styles: [
		`
			.fireworks-canvas {
				position: fixed; /* fijas sobre toda la ventana */
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				pointer-events: none; /* no bloquea clicks */
				z-index: 10000; /* por encima de cualquier overlay de PrimeNG */
			}
		`,
	],
})
export class FireworksComponent implements OnInit, OnDestroy {
	private confetti?: typeof confetti;

	/** Si querés disparar al init */
	@Input() autoLaunch = false;

	async ngOnInit(): Promise<void> {
		// Import dinámico para cargar solo cuando se use
		const module = await import('canvas-confetti');
		this.confetti = module.default;

		if (this.autoLaunch) {
			this.launch();
		}
	}

	/** Llamá este método desde donde quieras (click, evento, etc.) */
	launch() {
		if (!this.confetti) {
			return;
		}

		// Ejemplo de ráfaga de fuegos artificiales
		this.confetti({
			particleCount: 100,
			scalar: 1.2,
			ticks: 200,
			zIndex: 10000,
		});
	}

	ngOnDestroy() {
		if (this.confetti) {
			this.confetti.reset();
		}
	}
}
